/* @flow */

export const signupActivationForm = 'signupActivationForm';
export const signupEmailForm = 'signupEmailForm';
export const signupPasswordForm = 'signupPasswordForm';
export const signupAboutForm = 'signupAboutForm';
export const signupAvatarForm = 'signupAvatarForm';
